(function ($) {
    "use strict";
    $(function () {
        var lang_cookie = Cookies.get('_icl_current_language');
        if (lang_cookie == undefined) {
            lang_cookie = Cookies.get('wp-wpml_current_language');
        }


        moment.locale(lang_cookie);

        if ($('.template-programmes').length) {
            axios.post(localize.ajaxurl, $.param({
                action: 'get_epg',
                post_id: localize.post_id,
                lang: lang_cookie,

            }))
                .then(function (response) {

                    if (response.data.length) {
                        $.each(response.data, function (i, e) {
                            var schedule = e.schedule_start;
                            $('.js-next-airtimes').append(`
                    <tr>
                        <td>
                            <strong>${moment(schedule).format('dddd')}</strong> ${moment(schedule).format('(MMMM D.)')}
                        </td>
                        <td class="text-right">
                            <strong>${moment(schedule).format('HH:mm')}</strong>
                        </td>
                    </tr>
                    `);
                        });
                    } else {
                        $('.js-next-airtimes').append(`
                    <tr>
                        <td class="no-programmes">
                            ${localize.translations.noprogrammes}
                        </td>
                    </tr>
                `);
                    }

                    $('.js-next-airtimes-wrapper').fadeIn('fast');

                })
                .catch(function (error) {
                    console.log(error);
                });
        }

        if ($('.js-hero-slider').length) {
            axios.post(localize.ajaxurl, $.param({
                action: 'get_epg',
                recipes: true,
                lang: lang_cookie,

            }))
                .then(function (response) {


                    var rd = response.data;

                    var slides = 0;

                    if (rd.length) {

                        $.each(rd, function (i, e) {

                            var $related_recipes = e.related_recipes;

                            if (typeof $related_recipes !== 'undefined' && $related_recipes.length > 0) {
                                slides++;
                                $('.js-hero-slider').append(`
                                ${$related_recipes.map((item, i) => `
                                <a href="${item.permalink}" class="hero hero--recipes">
                                <div class="hero__overlay_top"></div>
                                <img class="img-fluid hero__image ofi-cover-center" src="${item.hero_kep.url}" alt="${item.title}">
                    
                                <div class="container">
                                    <div class="row">
                                        <div class="col-md-12">
                                            <div class="hero__details">
                                                <h1 class="hero__title text-uppercase text-white">
                                                    ${item.title}
                                                </h1>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                    
                                <div class="hero__overlay_bottom"></div>
                            </a>
                              `.trim()).join('')}
                              `)
                            }

                        });


                    }

                    if (slides != 0) {
                        $('.js-placeholder-hero').remove();

                        $('.js-hero-slider').slick({
                            arrows: false,
                            dots: true,
                            speed: 900,
                            fade: true,
                            autoplay: true,
                            autoplaySpeed: 10000,
                            cssEase: 'cubic-bezier(0.7, 0, 0.3, 1)',
                            touchThreshold: 100,
                            appendDots: ($('.js-hero-slider').hasClass('hero-slider--fullscreen')) ? $('.js-dots-wrapper') : $('.js-hero-slider')
                        });
                    }


                })
                .catch(function (error) {
                    console.log(error);
                });
        }


        if ($('.js-live-now').length) {
            axios.post(localize.ajaxurl, $.param({
                action: 'get_epg',
                limit: 3,
                lang: lang_cookie,

            }))
                .then(function (response) {

                    if (response.data.length) {
                        $.each(response.data, function (i, e) {
                            var schedule = e.schedule_start;
                            var name = e.name;
                            var url = e.url;
                            $('.js-live-now').append(`
                                <li class="menu__item no-hover" style="display:none;">
                                    <strong class="programme__date" >${moment(schedule).format('HH:mm')}</strong> ${(url) ? `<a class="programme__title" href="${url}">${name}</a>` : `${name}`}
                                </li>
                            `);
                        });

                        $('.js-loader').fadeOut('400', function () {
                            $('.js-live-now .menu__item').fadeIn().css("display", "inline-block");
                        })


                    }

                })
                .catch(function (error) {
                    console.log(error);
                });
        }

        if ($('.js-programmes-starting-time').length) {
            var epg_posts = [];
            $('.js-programmes-starting-time').each(function () {
                epg_posts.push($(this).data('id'));

            });


            axios.post(localize.ajaxurl, $.param({
                action: 'get_epg',
                lang: lang_cookie,
                epg_posts: epg_posts.filter($.onlyUnique)
            }))
                .then(function (response) {

                    if (response.data.length) {
                        $.each(response.data, function (i, e) {
                            var schedule = e.ss;

                            $(`.js-programmes-starting-time[data-id=${e.post_id}]`).hide().html(`
                                <span class="text-green">${moment(schedule).format('dddd')}</span>
                                ${moment(schedule).format('HH:mm')}
                            `).fadeIn();
                        });
                    }

                })
                .catch(function (error) {
                    console.log(error);
                });
        }

        $('.js-epg-hero-slider-custom').slick({
            arrows: false,
            dots: true,
            speed: 900,
            fade: true,
            autoplay: true,
            autoplaySpeed: 10000,
            cssEase: 'cubic-bezier(0.7, 0, 0.3, 1)',
            touchThreshold: 100,
            appendDots: ($('.js-epg-hero-slider-custom').hasClass('hero-slider--fullscreen')) ? $('.js-dots-wrapper') : $('.js-epg-hero-slider-custom')
        });

        let currentRequest = null;

        /* EPG PAGE TEMPLATE */
        function get_epg(epg_day, init) {

            // cancel  previous ajax if exists
            if (currentRequest) {
                currentRequest.cancel();
            }

            // creates a new token for upcomming ajax (overwrite the previous one)
            currentRequest = axios.CancelToken.source();

            axios.post(localize.ajaxurl, $.param({
                action: 'get_epg_for_a_day',
                lang: lang_cookie,
                date: epg_day,
            }), {
                cancelToken: currentRequest.token
            })
                .then(function (response) {
                    var rd = response.data;

                    var date_min = moment(rd.date_min);
                    var date_max = moment(rd.date_max);

                    /* Hero Slider */

                    if (init) {
                        $.each(rd.random_programs, function (i, e) {
                            var start = moment(e.schedule_start);
                            $('.js-epg-hero-slider').append(`
                            ${e.permalink ? `<a href="${e.permalink}" class="hero hero--programmes">` : `<div class="hero hero--programmes">`}
                            <div class="hero__overlay_top"></div>
                            <img class="img-fluid hero__image ofi-cover-center" src="${e.imgurl}" alt="${e.name}">
                             <div class="hero__details">
                                 <h1 class="hero__title text-uppercase text-white">
                                    ${e.name} 
                                 </h1>
            
                                 <h3 class="text-uppercase text-white"><span class="text-green">${start.format('dddd')}</span> ${start.format('HH:mm')}</h3>
                             </div>
                             <div class="hero__overlay_bottom"></div>
                             ${e.permalink ? `</a>` : `</div>`}
                        `)
                        });

                        $('.js-epg-hero-slider').slick({
                            arrows: false,
                            dots: true,
                            speed: 900,
                            fade: true,
                            autoplay: true,
                            autoplaySpeed: 10000,
                            cssEase: 'cubic-bezier(0.7, 0, 0.3, 1)',
                            touchThreshold: 100,
                            appendDots: ($('.js-epg-hero-slider').hasClass('hero-slider--fullscreen')) ? $('.js-dots-wrapper') : $('.js-epg-hero-slider')
                        });

                        /* EPG */
                        for (let m = moment(date_min), i = 0; moment().diff(m, 'days') >= -13; m.add(1, 'days'), i++) {
                            var current_date = m.format('YYYY-MM-DD');
                            $('.js-epg-slider').append(`
                            <div class="epg__date js-epg-date ${today == current_date ? 'active' : ''}" data-date="${current_date}" data-index="${i}">
                                <div class="date-wrapper">
                                    <div class="day__name">${m.format('ddd')}</div>
                                    <div class="day__number">${m.format('DD')}</div>
                                    <div class="month">${m.format('MMM.')}</div>
                                </div>
                            </div>
                        `);
                        }

                        $('.js-remove-placehoder-date').remove();

                        $('.js-epg-slider').slick({
                            infinite: false,
                            initialSlide: $('.epg__date.active').data('index'),
                            slidesToShow: 7,
                            centerMode: false,
                            variableWidth: false,
                            nextArrow: $('.js-epg-arrow-right'),
                            prevArrow: $('.js-epg-arrow-left'),
                            responsive: [
                                {
                                    breakpoint: 1200,
                                    settings: {
                                        slidesToShow: 6,
                                    }
                                },
                                {
                                    breakpoint: 992,
                                    settings: {
                                        slidesToShow: 4,
                                    }
                                },
                                {
                                    breakpoint: 656,
                                    settings: {
                                        slidesToShow: 3,
                                    }
                                },
                                {
                                    breakpoint: 500,
                                    settings: {
                                        slidesToShow: 2,
                                    }
                                },
                            ]
                        });
                    }

                    if (!init) {
                        $('.js-programmes').html('');
                    }

                    let first_show = true;

                    $.each(rd.programs, function (i, e) {
                        var end = moment(e.schedule_end);
                        var start = moment(e.schedule_start);
                        var $related_recipes = e.related_recipes;

                        $('.js-programmes').append(`
                        <div class="programme ${((end.format("YYYY-DD-MM HH:mm:ss") < moment().format("YYYY-DD-MM HH:mm:ss")) && epg_day == today) ? 'hide-programme' : ''}">
                       
    
                            <div class="programme__time">
                                <h3>${start.format('HH:mm')}</h3>
                            </div>
                            
                            <div class="programme__detail">
                                ${e.permalink ? ` <a href="${e.permalink}">` : `<div>`}
                                    <h3>${e.name} ${e.season && e.season != 0 ? `${$.convertToRoman(e.season)} / ${e.episode_no}. ${localize.translations.episode}` : ''} ${e.age_limit && e.age_limit != 0 ? `| (${e.age_limit})` : ''} </h3>
                                    <p> ${e.synopsis}</p>
                                
                                
                                    <p>
                                        ${(e.production_year && e.production_year != 0) ? `${localize.translations.year}: ${e.production_year}<br>` : ''}
                                        ${(e.actors) ? `${localize.translations.cast}: ${e.actors}<br>` : ''}
                                        ${localize.translations.playingtime}: ${moment(moment.duration(moment(end).diff(moment(start)))._data).format('HH:mm')}
                                    </p>
                                ${e.permalink ? `</a>` : `</div>`}
                                <div class="programme__recipes">
                                    ${(typeof $related_recipes !== 'undefined' && $related_recipes.length > 0) ? `<p>${localize.translations.related_recipes}</p>
                                    ${$related_recipes.map((item, i) => `
                                    <a href="${item.permalink}">${item.title}</a>
                                  `.trim()).join('')}` : ''}
                                </div>
                            </div>
                        </div>
                    `);

                        if (end.format("YYYY-DD-MM HH:mm:ss") >= moment().format("YYYY-DD-MM HH:mm:ss") && epg_day == today && first_show) {
                            if (localize.is_banner_enabled) {
                                $('.js-programmes').append(rd.banner);
                                first_show = false;
                            }
                        } else if (epg_day != today && first_show) {
                            if (localize.is_banner_enabled) {
                                $('.js-programmes').append(rd.banner);
                                first_show = false;
                            }
                        }
                    });

                    if (epg_day == today && $('.hide-programme').length) {
                        $('.js-programmes').prepend(`
                        <button class="button button--epg active js-epg-prev">
                            <span>${localize.translations.earlierprogrammes}</span>
                        </button>
                    `);
                    }

                    if (init) {
                        $('.js-fullscreen-loader').fadeOut(200, function () {
                            $('main').removeClass('fullheight');
                        });
                    } else {
                        $('.js-epg-loader').fadeOut('fast', function () {
                            $('.js-programmes').fadeIn('fast');
                        });
                    }
                })
                .catch(function (error) {
                    console.log(error);
                });
        }


        if ($('.template-epg').length) {


            var today = moment().format('YYYY-MM-DD');

            get_epg(today, true);

            $(document).on('click', '.js-epg-date', function (e) {
                e.preventDefault();
                var date = $(this).data('date');
                $('.js-epg-date.active').removeClass('active');
                $(this).addClass('active');
                $('.js-programmes').fadeOut('fast', function () {
                    $('.js-epg-loader').fadeIn('fast', function () {
                        get_epg(date, false);
                    });
                });
            });


            $(document).on('click', '.js-epg-prev', function (e) {
                e.preventDefault();
                $(this).toggleClass('active');
                $('.hide-programme').fadeToggle('400').css('display', 'block');
            });

        }

    });

})(jQuery);